export default __webpack_public_path__ + "static/media/hover-sound.1f40378e.mp3";